module.exports = __webpack_public_path__ + "img/6-TWK-Roadside-Information-Page-MVP.ba7aa6bf.png";